import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { Box, Text } from '@chakra-ui/react';
import { getChildrenProps } from '@varos/util-react';
import { createCategoryChartContainer } from './categoryContainer';
import { createCategoryView } from './categoryView';
export function createCategory(config, controller) {
    const DefaultTootip = (props) => {
        return (_jsx(Box, { children: _jsx(Text, { children: props.label }) }));
    };
    const DefaultSort = (props) => {
        return _jsx(_Fragment, {});
    };
    const Chart = createCategoryChartContainer(controller, createCategoryView());
    const components = {
        ChartRoot(props) {
            const childrenProps = getChildrenProps(props.children, {
                Grid: components.ChartGrid,
                Label: components.ChartLabel,
                Tooltip: components.ChartTooltip,
                LegendList: components.ChartLegendList,
                ScalarAxis: components.ChartScalarAxis,
                Bar: components.ChartBar,
                Row: components.ChartRow,
                Sort: components.ChartSort,
                SortIcon: components.ChartSortIcon,
            });
            const legendChildren = getChildrenProps(childrenProps.LegendList?.children, {
                LegendItem: components.ChartLegendItem,
                LegendTooltip: components.ChartLegendTooltip,
            });
            const sortChildren = getChildrenProps(childrenProps.Sort?.children, {
                Icon: components.ChartSortIcon,
            });
            const theme = {
                axis: {
                    tick: {
                        color: 'inherit',
                    },
                    label: {
                        visible: false,
                        color: 'inherit',
                    },
                },
                bar: {
                    ...childrenProps.Bar,
                    h: childrenProps.Bar?.h ?? 2,
                },
                row: {
                    spacing: childrenProps.Row.spacing,
                },
                legend: legendChildren.LegendItem
                    ? {
                        list: childrenProps.LegendList ?? {},
                        item: legendChildren.LegendItem ?? {},
                        tooltip: legendChildren.LegendTooltip ?? null,
                    }
                    : null,
                tooltip: {
                    gutter: childrenProps.Tooltip?.p,
                },
                grid: {
                    borderColor: childrenProps.Grid?.borderColor ?? 'whiteAlpha.500',
                },
                label: {
                    color: childrenProps.Label?.color ?? 'whiteAlpha.500',
                },
            };
            const fragments = {
                sort: sortChildren.Icon ?? {
                    asc: _jsx(_Fragment, {}),
                    desc: _jsx(_Fragment, {}),
                },
            };
            const axis = {
                scalar: childrenProps.ScalarAxis ?? {
                    unit: null,
                },
                time: null,
            };
            const Tooltip = childrenProps.Tooltip?.as ?? DefaultTootip;
            const containerProps = {
                theme: theme,
                fragments: fragments,
                axis: axis,
                Tooltip: Tooltip,
                datasets: props.datasets,
                labels: props.labels,
                type: props.type,
                series: props.series,
                sort: childrenProps.Sort ?? { column: 'value', direction: 'asc' },
            };
            return _jsx(Chart, { ...containerProps });
        },
        ChartLegendList() {
            return _jsx(_Fragment, {});
        },
        ChartBar() {
            return _jsx(_Fragment, {});
        },
        ChartLegendItem() {
            return _jsx(_Fragment, {});
        },
        ChartLegendTooltip() {
            return _jsx(_Fragment, {});
        },
        ChartGrid() {
            return _jsx(_Fragment, {});
        },
        ChartSort() {
            return _jsx(_Fragment, {});
        },
        ChartSortIcon() {
            return _jsx(_Fragment, {});
        },
        ChartRow() {
            return _jsx(_Fragment, {});
        },
        ChartLabel() {
            return _jsx(_Fragment, {});
        },
        ChartScalarAxis() {
            return _jsx(_Fragment, {});
        },
        ChartTooltip(props) {
            return _jsx(_Fragment, {});
        },
    };
    return {
        controller,
        Component: components,
    };
}
//# sourceMappingURL=categoryProvider.js.map